import axios from "axios";

const TOKEN_KEY = "ladupla_asesor_token";

export const advisorApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60000,
});

advisorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

advisorApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.includes("/asesor/auth/")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith("/asesor") && !window.location.pathname.startsWith("/asesor/login")) {
        window.location.assign("/asesor/login?expirada=1");
      }
    }
    return Promise.reject(err);
  },
);

export const advisorToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};
